import { clientPublic, clientPublicService } from 'helper/axios';
import { handleError } from 'helper/rest';
import { encodeIds } from 'helper/sqids';
let resError = ''
export const getDataPowerBI = async ({ token }) => {
  try {
    return await clientPublic
      .get(`powerbi?limit=20000000`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getDataPowerBIV2 = async ({ token }) => {
  try {
    const response = await clientPublicService.get(
      `/core/management/powerbi`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return {
      status: response.status,
      data: response.data.result,
      error: false,
    }
  } catch (error) {
    const { response } = error

    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }
    return {
      status: response?.status,
      data: null,
      error: true,
    }
  }
}

export const addPowerBI = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('powerbi', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}
export const updatePowerBI = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`powerbi/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const deletePowerBI = async ({ id, code, token }) => {
  try {
    return await clientPublic
      .delete(`powerbi/${id}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const GET_COMPANY_POWERBI = async ({ token }) => {
  try {
    return await clientPublic
      .get(`company/powerbi`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const GET_COMPANY_POWERBIV2 = async ({ token }) => {
  try {
    const response = await clientPublicService.get(
      `/core/company/powerbi`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return {
      status: response.status,
      data: response.data.result,
      error: false,
    }
  } catch (error) {
    const { response } = error || {}

    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }

    return {
      status: response?.status,
      data: null,
      error: true,
    }
  }
}

export const GET_COMPANY_POWERBI_NEW = async ({ token, status }) => {
  try {
    const response = await clientPublicService.get(
      `/core/company/powerbi`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          ...(status !== undefined && { status }),
        },
      }
    )

    return {
      status: response.status,
      data: response.data.result,
      error: false,
    }
  } catch (error) {
    const { response } = error || {}

    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }

    return {
      status: response?.status,
      data: null,
      error: true,
    }
  }
}

export const GET_PORJECT_GROUP = async ({ token }) => {
  try {
    return await clientPublic
      .get(`projectgroup/powerbi`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const GET_PROJECT_GROUP_V2 = async (token, ids) => {
  try {
    const response = await clientPublicService.get(
      `/core/project/project-group/company?company_ids=${encodeIds(ids)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return {
      status: response?.data?.status || response.status,
      data: response?.data?.result || [],
      error: false,
    }
  } catch (error) {
    const { response } = error || {}

    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }

    return {
      status: response?.data?.status || response?.status,
      data: [],
      error: true,
    }
  }
}

export const GET_PROJECT_CATEGORY = async (token, companyIds, groupIds) => {
  try {
    const response = await clientPublicService.get(
      `/core/project/project-category/company?company_ids=${encodeIds(companyIds)}&group_ids=${encodeIds(groupIds)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return {
      status: response?.data?.status || response.status,
      data: response?.data?.result || [],
      error: false,
    }
  } catch (error) {
    const { response } = error || {}

    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }

    return {
      status: response?.data?.status || response?.status,
      data: [],
      error: true,
    }
  }
}

export const GET_PROJECT_IMPERATIVE = async (token, categoryIds) => {
  try {
    const response = await clientPublicService.get(
      `/core/project/imperative/by-category-ids?category_ids=${encodeIds(categoryIds)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return {
      status: response?.data?.status || response.status,
      data: response?.data?.result || [],
      error: false,
    }
  } catch (error) {
    const { response } = error || {}

    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }

    return {
      status: response?.data?.status || response?.status,
      data: [],
      error: true,
    }
  }
}

export const GET_IMPACTTYPE = async (token, companyIds) => {
  try {
    const response = await clientPublicService.get(
      `/core/impacttype/company?company_ids=${encodeIds(companyIds)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return {
      status: response?.data?.status || response.status,
      data: response?.data?.result || [],
      error: false,
    }
  } catch (error) {
    const { response } = error || {}
    if (response && [401, 403].includes(response.status)) {
      return handleError(response)
    }
    return {
      status: response?.data?.status || response?.status,
      data: [],
      error: true,
    }
  }
}

export const GET_SEARCH_ACCOUNT = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('account/powerbi/search', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}
export const GET_POWER_BI_OF_ID = async ({ token, powerBi_id }) => {
  try {
    return await clientPublic
      .get(`powerbi/${powerBi_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
